export default {
    init() {

        // DOM Elements
        this.sliderBannerEl = $('.slider-banner')
        this.imageSliderBannerEl = $('.image-slider-banner')
        this.carouselSliderEl = $('.carousel-slider')
        this.reviewSliderEl = $('.review-slider')
        this.tabContentSliderEl = $('.tab-content-slider')
        this.tabProductSliderEl = $('.tab-product-slider')
        this.sliderFeaturedEl = $('.slider-featured')
        this.gridCarouselEl = $('.grid-carousel__wrapper')
        this.gridImageSelectorEl = $('.grid-image-selector__wrapper')
        this.onPageNav = $('.flex-row--navigation')
        this.bestSellersSliderEl = $('.best-sellers-slider')
      
        // Slider arrows
        this.arrowPrev = '<button type="button" class="slick-arrow slick-arrow--prev"><i class="fal fa-long-arrow-left fa-lg"></i></button>'
        this.arrowNext = '<button type="button" class="slick-arrow slick-arrow--next"><i class="fal fa-long-arrow-right fa-lg"></i></button>'
        // Alt Slider arrows
        this.arrowPrevAlt = '<button type="button" class="slick-arrow slick-arrow--prev"><i class="fal fa-chevron-left fa-lg"></i></button>'
        this.arrowNextAlt = '<button type="button" class="slick-arrow slick-arrow--next"><i class="fal fa-chevron-right fa-lg"></i></button>'

        // Alt Slider arrows
        this.anglePrevAlt = '<button type="button" class="slick-arrow slick-arrow--prev"><i class="far fa-angle-left"></i></button>'
        this.angleNextAlt = '<button type="button" class="slick-arrow slick-arrow--next"><i class="far fa-angle-right"></i></button>'

        if (this.sliderBannerEl.length) {
            this.sliderBanner()
        }
        
        if (this.imageSliderBannerEl.length) {
            this.imageBannerSlider()
        }
        
        if (this.carouselSliderEl.length) {
            this.carouselSlider()
        }

        if (this.reviewSliderEl.length) {
            this.reviewSlider()
        }

        if (this.tabContentSliderEl.length) {
            this.tabContentSlider()
        }

        if (this.tabProductSliderEl.length) {
            this.tabProductSlider()
        }

        if (this.sliderFeaturedEl.length) {
            this.sliderFeatured()
        }
        
        if (this.gridCarouselEl.length) {
            this.gridCarouselImages()
        }
        
        if (this.gridImageSelectorEl.length) {
            this.gridImageSelectorImages()
        }

        if (this.onPageNav.length) {
            this.onPageStickyNav()
        }

        if (this.bestSellersSliderEl.length) {
            this.bestSellersSlider()
        }

    },
    sliderBanner() {

        this.sliderBannerEl.slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 500,
            fade: true,
            rows: 0,
            cssEase: 'linear',
            prevArrow: this.arrowPrev,
            nextArrow: this.arrowNext,
        })

    },
    imageBannerSlider() {

        this.imageSliderBannerEl.slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 500,
            fade: true,
            rows: 0,
            cssEase: 'linear',
            prevArrow: this.arrowPrev,
            nextArrow: this.arrowNext,
        })

    },
    sliderFeatured() {

        const settings = {
            dots: true,
            arrows: true,
            infinite: false,
            rows: 0,
            slidesToScroll: 1,
            slidesToShow: 2,
            prevArrow: this.arrowPrev,
            nextArrow: this.arrowNext,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick',
                },
            ],
        }

        this.sliderFeaturedEl.slick(settings)

        $(window).on('resize', () => {
            if (!this.sliderFeaturedEl.hasClass('slick-initialized')) {
                return this.sliderFeaturedEl.slick(settings)
            }
        })

    },
    gridCarouselImages() {
        
        this.gridCarouselEl.slick({
            dots: false,
            arrows: false,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '37px',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: 'unslick',
                },
            ],
        })
        
    },
    gridImageSelectorImages() {
        
        // Do the same functionality on slick carousel swipe using $('.your-element').on('swipe', function(event, slick, direction){});
        $('.grid-image-selector__wrapper').on('swipe', function(slick, currentSlide) {
    
            // Get current slide index
            const currentSlideIndex = currentSlide.currentSlide;

            // Show carousel slide from another slick carousel which has a class of: .grid-image-selector__related-items-wrapper. Use 'slickGoTo'
            $('.grid-image-selector__related-items-wrapper').slick('slickGoTo', currentSlideIndex);
        
        });

        // Do the same as above but in reverse for the two carousels
        $('.grid-image-selector__related-items-wrapper').on('swipe', function(slick, currentSlide) {

            // Get current slide index
            const currentSlideIndex = currentSlide.currentSlide;

            // Show carousel slide from another slick carousel which has a class of: .grid-image-selector__wrapper. Use 'slickGoTo'
            $('.grid-image-selector__wrapper').slick('slickGoTo', currentSlideIndex);

        });
        
        this.gridImageSelectorEl.slick({
            dots: true,
            arrows: false,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            mobileFirst: true,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 480,
                    settings:
                    {
                        slidesToShow: 2,
                        slidesToScroll: 1,                       
                    },
                },
            ],
        })

        // Hide all related items except the first one
        document.querySelectorAll('.grid-image-selector__related-item:not(:first-child)').forEach(function(relatedItem) {
            relatedItem.classList.add('hidden');
        });

        // Attach click event listener to each .grid-image-selector__item element
        document.querySelectorAll('.grid-image-selector__item').forEach(function(item) {
            item.addEventListener('click', function() {

                const itemId = this.getAttribute('data-parent-id');
        
                // Hide all related items
                document.querySelectorAll('.grid-image-selector__related-item').forEach(function(relatedItem) {
                    relatedItem.classList.add('hidden');
                });
        
                // Show the related item with the matching data-related-id
                const relatedItem = document.querySelector(`.grid-image-selector__related-item[data-related-id="${itemId}"]`);
                if (relatedItem) {

                    // Scroll to the top of the related item
                    setTimeout(function () {
                        relatedItem.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        });
                    }, 100);

                    relatedItem.classList.remove('hidden');
                }
        
                // Add active class to the clicked item
                document.querySelectorAll('.grid-image-selector__item').forEach(function(item) {
                    item.classList.remove('active');
                });

                this.classList.add('active');
            });
        });
        

    },
    reviewSlider() {

        var prevArrow, nextArrow;

        if(this.reviewSliderEl.parent().closest('.flex-row--review-carousel').hasClass('slick-arrows-angle')) {prevArrow = this.anglePrevAlt; nextArrow = this.angleNextAlt; } else { prevArrow = this.arrowPrevAlt; nextArrow = this.arrowNextAlt; }

        this.reviewSliderEl.slick({
            slidesToShow: 2,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            autoSlidesToShow: true,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 1,
                    dots: false,
                    arrows: false,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    dots: false,
                    arrows: false,
                  },
                },
            ],
        })
    },
    tabContentSlider() {

        this.tabContentSliderEl.slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            fade: true,
            rows: 0,
            cssEase: 'linear',
            prevArrow: this.arrowPrevAlt,
            nextArrow: this.arrowNextAlt,
        })

        function updateSlickPosition($slickSlider) {
            setTimeout(function() {
                $slickSlider.slick('setPosition');
            }, 100); // Adjust timeout if necessary based on transition speeds
        }
        
        // Handle show and hide events for collapsible elements and tabs
        $('.collapse, a[data-toggle="tab"]').on({
            // runs on accordion changes
            'show.bs.collapse': function() {
                var $this = $(this);
                var $parentPane = $this.closest('.tab-pane');
                var $slider = $this.find('.tab-content-slider');
                var $allCollapses = $this.closest('.accordion-dynamic').find('.collapse');
            
                // Close other accordion tabs
                $allCollapses.not($this).collapse('hide').each(function() {
                    var $otherPane = $(this).closest('.tab-pane');
                    $otherPane.removeClass('show').addClass('hide');
                    $(this).prev('.card-header').find('.fas').removeClass('fa-chevron-up').addClass('fa-chevron-down');
                });
    
                // Update slick slider within the collapsing element
                updateSlickPosition($slider);
    
                // Update classes for the parent tab pane
                $parentPane.removeClass('hide').addClass('show');
    
                // Change icon to 'up' when shown
                $this.prev('.card-header').find('.fas').removeClass('fa-chevron-down').addClass('fa-chevron-up');
            },
            'hide.bs.collapse': function() {
                var $this = $(this);
                var $parentPane = $this.closest('.tab-pane');
    
                // Update classes for the parent tab pane
                $parentPane.removeClass('show').addClass('hide');
    
                // Change icon to 'down' when hidden
                $this.prev('.card-header').find('.fas').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            }, // runs on tab changes
            'shown.bs.tab': function(e) {
                var $targetPane = $($(e.target).attr('href')); // Target pane associated with the tab
                var $slider = $targetPane.find('.tab-content-slider');
                var $collapse = $targetPane.find('.collapse');
    
                // Update slick slider within the shown tab
                updateSlickPosition($slider);
    
                // Update classes for the shown tab pane and accordion
                $targetPane.removeClass('hide').addClass('show');
                $collapse.removeClass('hide').addClass('show');
            }, // runs on tab changes
            'hidden.bs.tab': function(e) {
                var $targetPane = $($(e.target).attr('href')); // Target pane associated with the tab
                var $collapse = $targetPane.find('.collapse');
    
                // Update classes for the hidden tab pane and accordion
                $targetPane.removeClass('show').addClass('hide');
                $collapse.removeClass('show').addClass('hide');
            },
        });

        const searchParams = new URLSearchParams(window.location.search);

        if (searchParams.has('tab')) {

            const activeTab = searchParams.get('tab');

            if (activeTab) {
                // Remove 'active' class from currently active tab and panel
                $('.nav-link.active').removeClass('active');
                $('.tab-pane.active').removeClass('active show');
                $('.tab-pane .collapse.show').removeClass('show');
    
                // Add 'active' class to the new active tab and panel
                $('a.nav-link[data-param="' + activeTab + '"]').addClass('active');
                $('div.tab-pane[data-param="' + activeTab + '"]').addClass('active');
                $('div.tab-pane[data-param="' + activeTab + '"] .collapse').addClass('show');

                $('div.tab-pane[data-param="' + activeTab + '"] .card-header i').removeClass('fa-chevron-down');
                $('div.tab-pane[data-param="' + activeTab + '"] .card-header i').addClass('fa-chevron-up');

                var navLink = $('a.nav-link[data-param="' + activeTab + '"]').attr('href');

                $(navLink).addClass('active show');

            }
        }
       

    },
    tabProductSlider() {

        this.tabProductSliderEl.slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            fade: true,
            rows: 0,
            cssEase: 'linear',
        })

        function updateSlickPosition($slickSlider) {
            setTimeout(function() {
                $slickSlider.slick('setPosition');
            }, 100); // Adjust timeout if necessary based on transition speeds
        }
        
        // Handle show and hide events for collapsible elements and tabs
        $('.collapse, a[data-toggle="tab"]').on({
            // runs on accordion changes
            'show.bs.collapse': function() {
                var $this = $(this);
                var $parentPane = $this.closest('.tab-pane');
                var $slider = $this.find('.tab-product-slider');
                var $allCollapses = $this.closest('.accordion-dynamic').find('.collapse');
            
                // Close other accordion tabs
                $allCollapses.not($this).collapse('hide').each(function() {
                    var $otherPane = $(this).closest('.tab-pane');
                    $otherPane.removeClass('show').addClass('hide');
                    $(this).prev('.card-header').find('.fas').removeClass('fa-chevron-up').addClass('fa-chevron-down');
                });
    
                // Update slick slider within the collapsing element
                updateSlickPosition($slider);
    
                // Update classes for the parent tab pane
                $parentPane.removeClass('hide').addClass('show');
    
                // Change icon to 'up' when shown
                $this.prev('.card-header').find('.fas').removeClass('fa-chevron-down').addClass('fa-chevron-up');
            },
            'hide.bs.collapse': function() {
                var $this = $(this);
                var $parentPane = $this.closest('.tab-pane');
    
                // Update classes for the parent tab pane
                $parentPane.removeClass('show').addClass('hide');
    
                // Change icon to 'down' when hidden
                $this.prev('.card-header').find('.fas').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            }, // runs on tab changes
            'shown.bs.tab': function(e) {
                var $targetPane = $($(e.target).attr('href')); // Target pane associated with the tab
                var $slider = $targetPane.find('.tab-product-slider');
                var $collapse = $targetPane.find('.collapse');
    
                // Update slick slider within the shown tab
                updateSlickPosition($slider);
    
                // Update classes for the shown tab pane and accordion
                $targetPane.removeClass('hide').addClass('show');
                $collapse.removeClass('hide').addClass('show');
            }, // runs on tab changes
            'hidden.bs.tab': function(e) {
                var $targetPane = $($(e.target).attr('href')); // Target pane associated with the tab
                var $collapse = $targetPane.find('.collapse');
    
                // Update classes for the hidden tab pane and accordion
                $targetPane.removeClass('show').addClass('hide');
                $collapse.removeClass('show').addClass('hide');
            },
        });
    },
    carouselSlider() {

        var dots, prevArrow, nextArrow;

        if(this.carouselSliderEl.parent().hasClass('slick-arrows-angle')) {prevArrow = this.anglePrevAlt; nextArrow = this.angleNextAlt; } else { prevArrow = this.arrowPrev; nextArrow = this.arrowNext; }
        if(this.carouselSliderEl.parent().hasClass('slick-no-dots')) { dots = false; } else { dots = true; }

        this.carouselSliderEl.slick({
            dots: dots,
            arrows: true,
            infinite: true,
            speed: 500,
            fade: true,
            rows: 0,
            cssEase: 'linear',
            prevArrow: prevArrow,
            nextArrow: nextArrow,
        })

        var carouselSliders = this.carouselSliderEl;

        // Determine screen size and select mobile or desktop vid
        function whichSizeVideo(element) {
            var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();

            if ( windowWidth > 1200 ) {
                // Extra large devices (large desktops, 1200px and up
                addSourceToVideo( element, element.dataset.desktopPoster, element.dataset.desktopWebm, 'video/webm');
                addSourceToVideo( element, element.dataset.desktopPoster, element.dataset.desktopMp4, 'video/mp4');
            } else if ( windowWidth >= 768 ) {
                // Medium devices (tablets, 768px and up)
                addSourceToVideo( element, element.dataset.tabletPoster, element.dataset.tabletWebm, 'video/webm');
                addSourceToVideo( element, element.dataset.tabletPoster, element.dataset.tabletMp4, 'video/mp4');
            } else {
                // Small devices
                addSourceToVideo( element, element.dataset.mobilePoster, element.dataset.mobileWebm, 'video/webm');
                addSourceToVideo( element, element.dataset.mobilePoster, element.dataset.mobileMp4, 'video/mp4');
            }
        }

        // Add source to video tag
        function addSourceToVideo(element, poster_src, src, filetype) {
            var source = document.createElement('source');

            // Check poster and src is not empty
            if ( poster_src && src ) {
                source.src = src;

                if( filetype == 'video/mp4' ) {
                source.classList.add('video-mp4');
                source.type = 'video/mp4';
                }
                
                if( filetype == 'video/webm' ) {
                source.classList.add('video-webm');
                source.type = 'video/webm';
                }

                // Check if the <video> tag already has <source> dom elements. If so, replace them with the new sources upon resize.
                if( element.hasChildNodes() ) {

                    // Set poster attribute to blank
                    element.setAttribute('poster', '');

                    if( filetype == 'video/mp4' ) {
                        $(element).find('.video-mp4').remove();
                    }

                    if( filetype == 'video/webm' ) {
                        $(element).find('.video-webm').remove();
                    }

                    // Add image URL to poster attribute
                    element.setAttribute('poster', poster_src);
                    
                    // Add new <source> dom elements
                    element.appendChild(source);
                    element.load();

                } else {

                    // Set poster attribute to blank
                    element.setAttribute('poster', '');

                    if( filetype == 'video/mp4' ) {
                        $(element).find('.video-mp4').remove();
                    }

                    if( filetype == 'video/webm' ) {
                        $(element).find('.video-webm').remove();
                    }

                    // Add image URL to poster attribute
                    element.setAttribute('poster', poster_src);
                    
                    // Add new <source> dom elements
                    element.appendChild(source);
                    element.load();

                }

            } else {
                console.log( 'Missing poster or src' );
            }

        }

        // Iterate through each carousel
        this.carouselSliderEl.each(function() {

            // Cache the carousel
            var carousel = $(this);

            // Get ID of carousel. This is the div which holds the slick settings too.
            var carouselId = carousel.attr('id') + '-carousel';

            // When carousel is touched on mobile, allow autoplay to continue.
            $('#' + carouselId).on('touchstart', function() {
                $('#' + carouselId).slick('slickPlay');
            });

            // Loop carousel items
            carousel.find('.slick-slide').each(function() {

                // Cache carousel item
                var slick_slide = $(this);

                // Get video element
                var video = slick_slide.find('video');

                // If video exists
                if (video.length) {

                // Pass video element to function
                whichSizeVideo(video[0]);

                }

            });

        });

        // Set variable which timeout is currently running.
        var resize_timeout;

        // Store the window width
        var windowWidth = $(window).width();

        // Re-init if page is resized.
        window.addEventListener('resize', function() {
        
            // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
            if ($(window).width() != windowWidth) {

                // Update the window width for next time
                windowWidth = $(window).width();

                clearTimeout(resize_timeout);

                carouselSliders.each(function() {

                    // Cache the carousel
                    var carousel = $(this);

                    // Loop carousel items
                    carousel.find('.slick-slide').each(function() {

                    // Cache carousel item
                    var slick_slide = $(this);

                    // Get video element
                    var video = slick_slide.find('video');

                    // If video exists
                    if (video.length) {

                        // Set timeout to prevent multiple re-inits
                        resize_timeout = setTimeout(function() {

                            // Pass video element to function
                            whichSizeVideo(video[0]);

                        }, 100);

                    }

                    });

                });
                
            }
        
        }, false);

    },
    onPageStickyNav() {

        const navContainer = this.onPageNav.find('.on-page-sticky-nav')
        const navInner = this.onPageNav.find('.on-page-sticky-nav__inner')
        const containerHeight = navContainer.height()

        $(window).scroll( () => {
            let target = navContainer.offset().top
            let scrollTop = $(window).scrollTop()

            if (scrollTop > target) {
                navContainer.css({
                    height: containerHeight,
                })

                navInner.css({
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    zIndex: '20',
                })
            } else if (scrollTop < target) {
                navContainer.css({
                    height: 'auto',
                })

                navInner.css({
                    position: 'relative',
                    top: 'auto',
                    left: 'auto',
                    zIndex: 'auto',
                })
            }
        })

        $('.page-nav-link').click( function(e) {
            e.preventDefault()

            // Active classes
            $('.page-nav-link').removeClass('active')
            $(this).addClass('active')

            // Scroll value
            const nav = $('.on-page-sticky-nav__inner')
            let scrollVal = $(this.hash).offset().top

            if (nav.length) {
                scrollVal = scrollVal - nav.height()
            }

            // Animate
            $('html, body').animate({
                scrollTop: scrollVal,
            }, 1000)
        })

    },
    bestSellersSlider() {

        this.bestSellersSliderEl.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 4000,
            cssEase: 'linear',
            prevArrow: this.arrowPrevAlt,
            nextArrow: this.arrowNextAlt,
            responsive: [
                {
                    breakpoint: 1400,
                    settings:
                    {
                        dots: true,
                        arrows: false,                       
                    },
                },
                {
                    breakpoint: 992,
                    settings:
                    {
                        slidesToShow: 3,  
                        dots: true,
                        arrows: false,                      
                    },
                },
                {
                    breakpoint: 768,
                    settings:
                    {
                        slidesToShow: 2,
                        dots: true,
                        arrows: false,                     
                    },
                },
                {
                    breakpoint: 480,
                    settings:
                    {
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,                     
                    },
                },
            ],
        })

    },
};
